import { combineReducers } from 'redux';

import defaultReminders from './default_reminders/reducer';

export default combineReducers({
  dealStagesConfig: dealStagesConfig => dealStagesConfig || {},
  defaultReminders,
  path: path => path || '',
  criticalDateOptions: criticalDateOptions => criticalDateOptions || [],
});
